import React, { useEffect, useState } from "react";
import { Avatar, Space, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";
import LogoutButton from "./logout_button";
import apiClient from "../api_client";
import { API_URL } from "../url_config";

const { Text } = Typography;

const UserHeader = () => {
  const [username, setUsername] = useState(
    localStorage.getItem("username") || ""
  );
  const [company, setCompany] = useState(
    localStorage.getItem("user_company") || ""
  );

  useEffect(() => {
    if (username) return;

    const fetchMe = async () => {
      try {
        const response = await apiClient.get(`${API_URL}/auth/me`);
        const data = response?.data ?? {};
        const fetchedUsername = data.username || "";
        const fetchedCompany = data.user_company || "";

        if (fetchedUsername) {
          localStorage.setItem("username", fetchedUsername);
          setUsername(fetchedUsername);
        }

        if (fetchedCompany) {
          localStorage.setItem("user_company", fetchedCompany);
          setCompany(fetchedCompany);
        }
      } catch (error) {
        // ignore
      }
    };

    fetchMe();
  }, [username]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1001,
        background:
          "linear-gradient(120deg, rgba(15,23,42,0.92), rgba(30,41,59,0.9))",
        borderBottom: "1px solid rgba(148, 163, 184, 0.35)",
        padding: "14px 22px",
        boxShadow: "0 14px 35px rgba(15, 23, 42, 0.25)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 16,
      }}
    >
      <Space size={12} align="center">
        <Avatar
          size={40}
          icon={<UserOutlined />}
          style={{
            background: "linear-gradient(135deg, #38bdf8, #6366f1)",
            boxShadow: "0 6px 16px rgba(56, 189, 248, 0.35)",
            border: "1px solid rgba(255,255,255,0.25)",
          }}
        />
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Text style={{ color: "#f8fafc", fontWeight: 700, fontSize: 15 }}>
            {username || "Utilisateur"}
          </Text>
          {company ? (
            <Text style={{ color: "#cbd5f5", fontSize: 12, letterSpacing: 0.2 }}>
              {company}
            </Text>
          ) : null}
        </div>
      </Space>
      <LogoutButton />
    </div>
  );
};

export default UserHeader;
